import clsx from 'clsx';
import React, { useState } from 'react';
import { UiFlex } from '../..';
import './UiInputPhone.css';
import { UiInput } from '../UiInput';
var areaCodes = ['47', '46', '45', '372'];
export function useUiInputPhone() {
    var _a = useState(areaCodes[0] || ''), areaCode = _a[0], setAreaCode = _a[1];
    var _b = useState(''), phone = _b[0], setPhone = _b[1];
    function reset() {
        setAreaCode('');
        setPhone('');
    }
    return {
        element: (React.createElement(UiInputPhone, { areaCode: areaCode, phone: phone, onChange: function (_a) {
                var areaCode = _a.areaCode, phone = _a.phone;
                setAreaCode(areaCode);
                setPhone(phone);
            } })),
        areaCode: areaCode,
        setAreaCode: setAreaCode,
        phone: phone,
        setPhone: setPhone,
        isValid: function () {
            return areaCode && phone.length > 5;
        },
        reset: reset,
    };
}
export function UiInputPhone(_a) {
    var areaCode = _a.areaCode, phone = _a.phone, onChange = _a.onChange, disabled = _a.disabled, isLoading = _a.isLoading, className = _a.className;
    return (React.createElement(UiFlex, { className: clsx('UiInputPhone', className), flexChildren: true },
        React.createElement(UiInput, { value: areaCode, onChangeValue: function (areaCode) { return onChange({ areaCode: areaCode, phone: phone }); }, options: areaCodes.map(function (areaCode) { return ({
                label: "+" + areaCode,
                value: areaCode,
            }); }), disabled: disabled, isLoading: isLoading, name: "area-code", className: "area-code", noBorder: true }),
        React.createElement(UiInput, { value: phone, onChangeValue: function (phone) { return onChange({ areaCode: areaCode, phone: phone }); }, disabled: disabled, isLoading: isLoading, name: "phone", type: "tel", label: "Phone", noBorder: true })));
}
